import React from "react";

function Footer() {
  return (
    <footer class="bg-white rounded-t-lg dark:bg-gray-900 w-screen">
      <div class="max-w-6xl mx-auto p-4 md:px-6 md:py-8">
        <div class="flex flex-col sm:flex-row items-center justify-between">
          <svg
            className="cursor-pointer h-8 mr-3 mb-4 sm:mb-0 fill-black dark:fill-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1101.41 256.28"
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
          >
            <g data-name="Layer 2">
              <text
                transform="matrix(.98 0 -.19 .98 166.57 208.25)"
                style={{
                  fontSize: "252.17px",
                  fontFamily: "Teko-Medium,Teko",
                  fontWeight: 500,
                }}
              >
                {"Kushantha"}
              </text>
            </g>
          </svg>

          <ul class="flex flex-wrap items-center text-sm font-medium gap-5 text-gray-500 sm:mb-0 dark:text-gray-400">
            <li>
              <a
                href="https://www.linkedin.com/in/kushantha-sajith/"
                class="hover:text-my-purple-400 transition-colors duration-200 ease-in-out"
                target={"_blank"}
              >
                LinkedIn
              </a>
            </li>
            <li>
              <a
                href="https://github.com/kushantha-sajith"
                class="hover:text-my-purple-400 transition-colors duration-200 ease-in-out"
                target={"_blank"}
              >
                GitHub
              </a>
            </li>
            {/* <li>
              <a
                href="https://www.behance.net/#"
                class="hover:text-my-purple-400 transition-colors duration-200 ease-in-out"
                target={"_blank"}
              >
                Behance
              </a>
            </li> */}
            <li>
              <a
                href="https://kushanthasajith.medium.com/"
                class="hover:text-my-purple-400 transition-colors duration-200 ease-in-out"
                target={"_blank"}
              >
                Medium
              </a>
            </li>
            <li>
              <a
                href="mailto:kushantha018@gmail.com"
                class="hover:text-my-purple-400 transition-colors duration-200 ease-in-out"
                target={"_blank"}
              >
                Gmail
              </a>
            </li>
          </ul>
        </div>
        <hr class="my-6 border-gray-300 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <span class="text-center block text-sm text-gray-500 sm:text-center dark:text-gray-400">
          © 2025{" "}
          <a
            href="https://kushantha-sajith.web.app/"
            class="hover:text-my-purple-400 transition-colors duration-200 ease-in-out"
          >
            Kushantha
          </a>
          . All Rights Reserved.
        </span>
      </div>
    </footer>
  );
}

export default Footer;
